import React, { useCallback } from 'react';
import { usePasswordChangeEmailSend } from 'Hooks/Auth';
import { useToggler } from 'Hooks/Common';
import Toast from 'Services/Toast';

import CheckInbox from './components/CheckInbox';
import ResetForm from './components/ResetForm';

const ForgotPassword = () => {
  const [isSubmitted, toggleIsSubmitted] = useToggler(false);
  const [sendPasswordChangeEmail] = usePasswordChangeEmailSend();
  const handlePasswordChangeEmailSend = useCallback(
    async values => {
      try {
        await sendPasswordChangeEmail(values);
        toggleIsSubmitted();
      } catch (error) {
        Toast.handleErrors(error);
      }
    },
    [sendPasswordChangeEmail, toggleIsSubmitted],
  );

  if (!isSubmitted) {
    return <ResetForm onSubmit={handlePasswordChangeEmailSend} />;
  }

  return <CheckInbox />;
};

export default ForgotPassword;
